export const AuthSortides = ({ auth, handleChange, error }) => {

  return (
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Responsabilització sortides
        </h4>
        <p>
          <input type="checkbox" id="authSortides" name="authSortides" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authSortides"> Em RESPONSABILITZO dels desplaçaments que faci pel meu compte cap/des de punts preestablerts en activitats i sortides del centre.  </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

        <br />

      </div>
    </div>
  )
}

export const AuthSortidesMenors = ({ auth, handleChange, error, curs, cicle }) => {

  return (
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Autorització per a realitzar activitats fora del centre
        </h4>
        <p>
          <input type="checkbox" id="authSortides" name="authSortides" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authSortides">
            AUTORITZO a l'alumnat matriculat a:
            <ul>

              <li>l'alumne realitzi les sortides programades durant el curs escolar.</li>
              {(curs.id.startsWith("BATXLOE")
                || cicle === "CFGM")
                && (
                  <>
                    <li>si escau, l'alumne es quedi en el destí de la sortida o punts intermitjos (per exemple estacions de tren entre el destí i l’origen) durant el curs escolar quedant el centre exonerat de la responsabilitat de guàrdia i custòdia.</li>
                    <li>si escau, l'alumne vagi directament al destí de la sortida o lloc de sortida diferent del centre (per exemple estació de tren) durant el curs escolar.</li>
                    <li>l'alumne pugui sortir del centre durant el temps d'esbarjo quedant el centre exonerat de la responsabilitat de guàrdia i custòdia.</li>
                    <li>l'horari de l'alumne sigui modificat si hi ha alteracions i pugui sortir abans o entrar més tard quedant el centre exonerat de la responsabilitat de guàrdia i custòdia</li>
                  </>
                )}
            </ul>

          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  )
}
